import ReactDatePickerImport from "react-datepicker"

type CommonJsInterop<T> = T & { default?: T }

const ReactDatePicker =
  (ReactDatePickerImport as CommonJsInterop<typeof ReactDatePickerImport>)
    .default ?? ReactDatePickerImport
type ReactDatePicker = ReactDatePickerImport

export default ReactDatePicker
export type { ReactDatePickerProps } from "react-datepicker"
